<template>
  <!-- 表三 -->
  <div class="form-container">
    <div class="form-title margin-b20">表3-产品单元划分</div>
    <div class="table-wrapper table-3">
      <div class="table-header-wrapper">
        <div class="table-header">
          <div class="table-header-item one">覆盖范围</div>
          <div class="table-header-item two">产品名称</div>
          <div class="table-header-item three">限制范围</div>
        </div>
      </div>
      <div class="table-body-wrapper">
        <div class="table-body">
          <div
            class="table-body-item"
            v-for="(item, index) in evaluationProductList"
            :key="index"
          >
            <div class="one">{{ `${item.level}级` }}</div>
            <div class="two">{{ item.productName }}</div>
            <div class="three">{{ item.scopeOfApplication }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    evaluationProductList: { type: Array, default: () => [] }
  },
  data() {
    return {};
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.table-3 {
  .table-header {
    height: 40px;
    display: flex;
    background: #f5f5f5;
    border: 1px solid #dcdcdc;
    .table-header-item {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333;
      font-size: 12px;
      font-weight: 500;
      border-right: 1px solid #dcdcdc;
      &:last-child {
        border-right: none;
      }
    }
    .one {
      flex: 1.5;
    }
    .two {
      flex: 5;
    }
    .three {
      flex: 7;
    }
  }
  .table-body-wrapper {
    border: 1px solid #dcdcdc;
    border-top: none;
    .table-body {
      .table-body-item {
        min-height: 50px;
        display: flex;
        color: #333;
        font-size: 12px;
        font-weight: 500;
        border-top: 1px solid #dcdcdc;
        &:first-child {
          border-top: none;
        }
        & > div {
          display: flex;
          justify-content: center;
          align-items: center;
          border-right: 1px solid #dcdcdc;
          &:last-child {
            border-right: none;
          }
        }
        .one {
          flex: 1.5;
        }
        .two {
          flex: 5;
        }
        .three {
          flex: 7;
        }
      }
    }
  }
}
</style>
